import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import imagesData from '../data/images';

function GalleryDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Szukamy obrazu o danym id
  const image = imagesData.find((img) => img.id === parseInt(id, 10));

  // Obsługa przypadku, gdy nie znaleziono obrazu
  if (!image) {
    return (
      <div className="container-fluid mt-4">
        <h2 className="text-center">Brak obrazu</h2>
        <p className="text-center">Nie znaleziono obrazu o podanym ID.</p>
        <div className="d-flex justify-content-center mt-3">
          <Link to="/galeria" className="btn btn-secondary">
            Powrót do galerii
          </Link>
        </div>
      </div>
    );
  }

  // Wyświetlamy szczegóły obrazu
  return (
    <div className="container-fluid mt-4">
      <h2 className="text-center">{image.title}</h2>
      
      <div className="row justify-content-center ">
        <div className="col-12 col-md-8 text-center">
          <img
            src={image.src}
            alt={image.title}
            className="img-fluid d-block mx-auto mb-3"
            style={{ maxWidth: '100%' }}
          />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <p className="text-center">{image.description}</p>
        </div>
      </div>
      
      <div className="d-flex justify-content-center gap-2 mt-3">
        <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
          Cofnij
        </button>
      </div>
    </div>
  );
}

export default GalleryDetail;
